export interface PolicyDocumentRequest {
    empresa:                string;
    sucursal:               string;
    articulo:               string;
    superpoliza:            string;
    suplementoSuperpoliza:  string;
    rama:                   string;
    numeroPoliza:           string;
    suplementoPoliza:       string;
    documento:              string;
}

export interface PolicyDocumentServiceResponse{
    base64: string
}

export enum PolicyCreatorDocumentType {
    POLIZA_COMPLETA = 'polizaCompleta',
    POLIZA_REDUCIDA = 'polizaReducida',
    POLIZA_FACTURAASEGURADO = 'facturaAsegurado',
    POLIZA_FACTURAORGANIZADOR = 'facturaOrganizador',
    POLIZA_FACTURAPRODUCTOR = 'facturaProductor',
    POLIZA_TARJETACIRCULACION = 'tarjetaCirculacion',
    POLIZA_CUPONERA = 'cuponera',
}
